import React from 'react';

import cn from 'classnames';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import Link from 'redux-first-router-link';
import { Text } from 'scouting-ui/lib/Text';
import { cssVars } from 'scouting-ui/lib/variables';

import styles from './ReturnLink.module.scss';

export interface ReturnLinkProps {
  /** Anything `redux-first-router-link` accepts: a path or a route action. */
  to: React.ComponentProps<typeof Link>['to'];
  /** Defaults to "Return". */
  children?: React.ReactNode;
  className?: string;
}

/**
 * Back navigation to a parent screen.
 *
 * A real anchor rather than a button, so middle-click and open-in-new-tab work.
 * Use `ReturnButton` instead when the target is a modal or a step in a flow
 * that has no URL of its own.
 */
export default function ReturnLink(props: ReturnLinkProps) {
  const { to, children, className } = props;

  return (
    <Link to={to} className={cn(styles.link, className)}>
      <MdKeyboardArrowLeft
        className={styles.arrow}
        color={cssVars['color-info']}
      />
      <Text strong font="body-body-3" color="color-info">
        {children ?? <FormattedMessage id="shared.ReturnLink.text" />}
      </Text>
    </Link>
  );
}
